import React from 'react';
import { Stack, Typography, useTheme, useMediaQuery } from '@mui/material';
import {
  FolderCardWrapper,
  FolderCardWrapperMobile,
  RedLinkButton,
  FolderCardCTAWrapperMobile,
} from './styles';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import translations from 'utils/translations';
import { useIntl } from 'react-intl';
import {
  useBookmarkSelector,
  useBookmarkStore,
} from 'pages/exhibitor/exhibitorBookmarks';

const FolderCard = ({
  folder,
  onDelete,
  onEdit,
  mobileFolderClicked = null,
}) => {
  const intl = useIntl();
  const i18n = translations.ExhibitorsV2(intl);
  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const { isEditing } = useBookmarkSelector();

  return (
    <>
      {isLgUp ? (
        <FolderCardWrapper
          onClick={(event) => {
            event.stopPropagation();
            useBookmarkStore.setState({ currentFolderOnView: folder });
          }}
        >
          <Stack gap={'5px'}>
            <FolderOpenIcon fontSize="small" />
            <Typography color={theme.palette.grey[900]} variant={'body2-bold'}>
              {folder?.name || ''}
            </Typography>
            <Typography color={theme.palette.grey[800]} variant="s">
              {`${folder?.exhibitors?.length} ${
                i18n.PersonalPage.folderCard[
                  folder?.exhibitors?.length === 1 ? 'exhibitor' : 'exhibitors'
                ]
              }` || ''}
            </Typography>
          </Stack>
          {isEditing ? (
            <Stack flexDirection={'row'} justifyContent={'space-between'}>
              <RedLinkButton
                rightIcon={
                  <DeleteOutlineOutlinedIcon
                    fontSize="small"
                    htmlColor={theme.palette.primary.main}
                  />
                }
                variant="link2"
                onClick={(event) => {
                  event.stopPropagation();
                  onDelete(folder);
                }}
                msg={i18n.Common.delete}
              ></RedLinkButton>
              <RedLinkButton
                rightIcon={
                  <ModeEditOutlineOutlinedIcon
                    fontSize="small"
                    htmlColor={theme.palette.primary.main}
                  />
                }
                variant="link2"
                onClick={(event) => {
                  event.stopPropagation();
                  onEdit(folder);
                }}
                msg={i18n.Common.edit}
              ></RedLinkButton>
            </Stack>
          ) : null}
        </FolderCardWrapper>
      ) : (
        <FolderCardWrapperMobile
          onClick={(event) => {
            event.stopPropagation();
            useBookmarkStore.setState({ currentFolderOnView: folder });
            mobileFolderClicked?.();
          }}
        >
          <Stack gap={'5px'}>
            <Typography color={theme.palette.grey[900]} variant={'body2-bold'}>
              {folder?.name || ''}
            </Typography>
            <Typography color={theme.palette.grey[800]} variant="s">
              {`${folder?.exhibitors?.length} ${
                i18n.PersonalPage.folderCard[
                  folder?.exhibitors?.length === 1 ? 'exhibitor' : 'exhibitors'
                ]
              }` || ''}
            </Typography>
          </Stack>
          {isEditing ? (
            <Stack flexDirection={'row'} gap={'15px'}>
              <FolderCardCTAWrapperMobile>
                <ModeEditOutlineOutlinedIcon
                  fontSize="small"
                  htmlColor={theme.palette.primary.main}
                  onClick={(event) => {
                    event.stopPropagation();
                    onEdit(folder);
                  }}
                />
              </FolderCardCTAWrapperMobile>
              <FolderCardCTAWrapperMobile>
                <DeleteOutlineOutlinedIcon
                  fontSize="small"
                  htmlColor={theme.palette.primary.main}
                  onClick={(event) => {
                    event.stopPropagation();
                    onDelete(folder);
                  }}
                />
              </FolderCardCTAWrapperMobile>
            </Stack>
          ) : null}
        </FolderCardWrapperMobile>
      )}
    </>
  );
};

export default FolderCard;
